import { useState } from 'react';
import Arrow from '../../assets/icons/chevron-right--yellow.svg';
import { SContainer, SExpandedBody, SMainWrapper, SNamTitle } from './ArrowCollapsibleCard.styles';

type IArrowCollapsibleCardProps = {
  title: string;
  children?: React.ReactNode | React.ReactNode[];
};

export const ArrowCollapsibleCard = (props: IArrowCollapsibleCardProps) => {
  const { title, children } = props;
  const [expanded, setExpanded] = useState<boolean>(false);

  const toggleExpand = () => {
    setExpanded(prev => !prev);
  };

  const renderContent = () => (
    <SExpandedBody $expanded={expanded} role="cardExpandedBody">
      <>&nbsp;{children}</>
    </SExpandedBody>
  );
  return (
    <SContainer role="collapsibleCard">
      <SMainWrapper onClick={toggleExpand} $expanded={expanded} role="cardContent">
        <SNamTitle role="title">{title}</SNamTitle>
        <div className="image" role="iconContainer">
          <img src={Arrow} alt="right-arrow" role="icon" />
        </div>
      </SMainWrapper>
      {renderContent()}
    </SContainer>
  );
};
